<template>
  <div
    class="c-app flex-row align-items-center container-fluid"
    :style="{
      backgroundImage: `url(${require('@/assets/Stara_login.png')})`,
    }"
    :class="{ 'c-dark-theme': $store.state.darkMode }"
  >
    <img style="top: 0; left: 0; width: 25%; position: absolute" src="@/assets/Logo-login.png" />
    <CContainer>
      <CRow class="justify-content-end">
        <CCol md="4">
          <CCardGroup>
            <!-- <CCard class="p-4" style="border: 1px solid transparent; background-color: rgba(225, 225, 225, 0.6)"> -->
            <CCard class="p-4" style="border: 1px solid transparent; background-color: transparent">
              <CCardBody>
                <CForm>
                  <!-- <p style="font-size: 28px; line-height: 30px; letter-spacing: 1px">Login</p> -->
                  <p class="">Sign In to your account</p>
                  <b-alert dismissible fade :show="showing" :variant="variant">{{ msg }}</b-alert>
                  <CInput placeholder="Kode" v-model="kode">
                    <template #append-content><CIcon name="cil-code" /></template>
                  </CInput>
                  <CInput placeholder="Username" v-model="username">
                    <template #append-content><CIcon name="cil-user" /></template>
                  </CInput>
                  <CInput placeholder="Password" :type="showPassword ? 'text' : 'password'" v-model="password" v-on:keyup.enter="signin()">
                    <template #append-content>
                      <b-icon :icon="showPassword ? 'eye' : 'eye-slash'" @click="showPassword = !showPassword" />
                      <!-- <CIcon name="cil-lock-locked"/> -->
                    </template>
                    <!-- <template #append-content><CIcon name="cil-lock-locked" /></template> -->
                  </CInput>
                  <CRow>
                    <CCol col="12" class="text-left">
                      <CButton @click="signin()" class="px-4 btn btn-primary w-100">
                        <b-spinner v-if="loading" variant="light" label="Spinning"></b-spinner>
                        <!-- <span v-if="loading">Mohon tunggu</span> -->
                        <span v-else>Login</span>
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      showPassword: false,
      kode: "",
      username: "",
      password: "",
      showing: false,
      loading: false,
      variant: "success",
      msg: "",
    };
  },
  methods: {
    async signin() {
      let vm = this;
      vm.$store.commit("set_kode_client", vm.kode);
      await new Promise((resolve) => setTimeout(resolve, 10));
      vm.$axios
        .post("user/login", {
          // .post(vm.kode + "/user/login", {
          username: vm.username,
          password: vm.password,
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "sukses") {
            let hasilRole = [];
            const role = res.data.data[0].dataRole || [];
            for (let i = 0; i < role.length; i++) {
              const x = role[i];
              console.log(x.kodeRole != "karyawan");
              if (x.kodeRole != "karyawan") hasilRole.push(x);
            }
            // console.log("lolos", hasilRole);
            if (hasilRole.length) {
              res.data.data[0].dataRole = hasilRole;
              vm.$store.commit("set_kode_client", vm.kode);
              vm.$store.commit("set_token", res.data.data[0]);
              vm.$store.commit("set_alert", {
                variant: "success",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
              if (hasilRole[0].kodeRole == "super") {
                vm.$router.push({ path: "/dashboard" });
              } else {
                vm.$router.push({ path: "/jadwal" });
              }
            } else {
              vm.$store.commit("set_alert", {
                variant: "warning",
                msg: "Anda tidak memiliki akses pada aplikasi web ini",
                showing: true,
              });
            }
          } else {
            vm.$store.commit("set_alert", {
              variant: "warning",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.$store.commit("set_alert", {
            variant: "danger",
            msg: err,
            showing: true,
          });
        });
    },
  },
};
</script>

<style scoped>
.container-fluid {
  /* background-image: url('@/assets/gedung.jpeg') */
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  min-height: 100vh;
  /* background-color:  rgba(225, 225, 225, 0.1); */
  padding: 7%;
  /* filter: blur(0rem); */

  /* color: aqua; */
}
</style>
